import React from 'react';

const FieldGroup = ({children, ...props}) => {


    const className = () => {
        let output = 'relative floating-label';

        if(props.full) {
            output += 'col-span-12';
        } else {
            output += 'col-span-full md:col-span-6';
        }

        if (props.hasError) {
            output += ' error';
        }

        return output;
    }

    return (
        <div className={className()}>
            {children}
        </div>
    );
};

export default FieldGroup;
